module.exports = __webpack_public_path__ + "img/exportar.3031995a.svg";